import { mapState } from 'vuex'
import { isVendaNaoGerada } from '../../plugins/helpers'

export default {
  computed: {
    ...mapState([
      'id_comissionado',
      'comissionados',
      'modalidades',
      'id_comissionado_venda'
    ])
  },
  methods: {
    isRascunho (item) {
      return item.status_pedido && isVendaNaoGerada(item.status_pedido)
    },
    grupoDescription (item) {
      if (item.reserva_agrupada) {
        return this.groupFormat(item.cd_grupo || item?.grupo?.cd_grupo)
      }
      let grupo = (((item.grupo && item.grupo.cd_grupo) || item.cd_grupo) ? this.groupFormat(item?.grupo?.cd_grupo || item.cd_grupo) : 'Grupo não identificado')
      if (item.cd_cota) {
        grupo += '/' + item.cd_cota
      }
      return grupo
    },
    getComissionado (id_comissionado) {
      let comissionado = this['comissionados'].find(comissionado => comissionado.ID_Comissionado === id_comissionado || comissionado.idComissionado === id_comissionado)
      return this.comissionadoDescription(comissionado)
    },
    getTipoProduto (id_produto, multiplo) {
      const produtoId = String(id_produto)
      let nome_produto = this.getModalidade(produtoId).nome

      if (multiplo && nome_produto) {
        nome_produto += ' - RESERVA MÚLTIPLA'
      } else if (multiplo) {
        return 'RESERVA MÚLTIPLA'
      }
      return nome_produto || ''
    },
    getModalidade (id_produto) {
      const produtoId = String(id_produto)

      return Object.values(this.modalidades).find(modalidade => {
        return modalidade.produtos.some(produto => produto.id_produto === produtoId)
      }) || {}
    },
    formatarReal (value) {
      return Number(value).toLocaleString('pt-BR', {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
      })
    },
    formatNumber (n) {
      return n.toFixed(2).toString().replace(/\./g, ',')
    },
    groupFormat (cd_grupo) {
      if (!cd_grupo) {
        return '-'
      }
      return String(cd_grupo).replace(/^(0+)(\d)/g, '$2')
    },
    comissionadoDescription (comissionado) {
      if (!comissionado) return '-'
      const codigo_comissionado = comissionado.codigoComissionado || comissionado['CD_Comissionado']
      const nome_comissionado = comissionado.nomeComissionado || (comissionado['NM_Pessoa'])
      if (this.id_comissionado === this.id_comissionado_venda) {
        return comissionado ? `${codigo_comissionado} - ${this.abrevia(nome_comissionado)}` : '-'
      }
      return comissionado ? `${this.abrevia(nome_comissionado)}` : '-'
    },
    abrevia (str) {
      if (!str) {
        return ''
      }
      const nome = str.replace(/\s+/gi, ' ').trim()
      let array_nome = nome.split(' ')
      if (array_nome.length > 2) {
        return array_nome.map((parte, index) => (index !== 1) ? parte : `${parte[0]}.`).join(' ')
      } else {
        return str
      }
    }
  }
}
